import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-slotted-notes',
  templateUrl: './slotted-notes.component.html',
  styleUrls: ['./slotted-notes.component.css']
})
export class SlottedNotesComponent implements OnInit {

  @Input() fgSlottedPipe : UntypedFormGroup;

  constructor() { }

  ngOnInit(): void {
  }

}
